import { PresentationDeckCategory } from './types';

export const UNCATEGORIZED_DECK_FILTER = 'uncategorized';

export function parentDeckCategoryId(category: Pick<PresentationDeckCategory, 'parentCategory'>): string | null {
  const parent = category.parentCategory as unknown;
  if (!parent) return null;
  if (typeof parent === 'string') return parent;
  if (typeof parent === 'object' && parent && '_id' in parent) return String((parent as { _id: unknown })._id);
  return String(parent);
}

export function expandDeckCategorySelection(
  selectedId: string,
  categories: PresentationDeckCategory[]
): string[] {
  const ids = [selectedId];
  for (const category of categories) {
    if (parentDeckCategoryId(category) === selectedId) {
      ids.push(...expandDeckCategorySelection(category._id, categories));
    }
  }
  return Array.from(new Set(ids));
}

export function rootDeckCategories(categories: PresentationDeckCategory[]): PresentationDeckCategory[] {
  return categories
    .filter((category) => !parentDeckCategoryId(category))
    .sort((a, b) => (a.order - b.order) || a.name.localeCompare(b.name, 'sv'));
}

export function childDeckCategories(
  categories: PresentationDeckCategory[],
  parentId: string
): PresentationDeckCategory[] {
  return categories
    .filter((category) => parentDeckCategoryId(category) === parentId)
    .sort((a, b) => (a.order - b.order) || a.name.localeCompare(b.name, 'sv'));
}

export function deckCategoryLabel(
  categories: PresentationDeckCategory[],
  id: string | null | undefined
): string | null {
  if (!id) return null;
  return categories.find((category) => category._id === id)?.name || null;
}
